import { useQuery as useQueryBase, } from '@tanstack/react-query';
import { request } from '../../request';
export function useQuery(key, query, variables, options, responseMapper = (response) => response, onCatch) {
    let cacheKey = key;
    if (variables) {
        cacheKey = [...cacheKey, variables];
    }
    return useQueryBase({
        queryKey: cacheKey,
        queryFn: async () => {
            try {
                const response = await request({
                    query,
                    variables,
                });
                return responseMapper(response);
            }
            catch (err) {
                if (onCatch)
                    return onCatch(err);
                else
                    throw err;
            }
        },
        ...options,
    });
}
//# sourceMappingURL=useQuery.js.map